import React from 'react';
import { Link } from 'react-router-dom';

function Oncology() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* MOBILE BREAKPOINT STYLES OVERRIDE */}
      <style>{`
        @media (max-width: 550px) {
          .oncology-footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
        }
      `}</style>

      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Oncology & Advanced Cancer Treatment in Delhi NCR: Premium Private Care Guide for International Patients
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '24px' }}>
          Receiving a complex oncology diagnosis brings significant emotional and financial stress, especially when navigating exhausting wait times or high out-of-pocket costs in Western or regional healthcare systems. For international patients seeking world-class clinical solutions, the private healthcare infrastructure in the Delhi National Capital Region (NCR)—encompassing New Delhi, Gurgaon, and Noida—offers an elite, accessible pathway. 
          By cross-referencing public data on independent informational directories like <strong>Medical Trip World</strong>, international families can research state-of-the-art therapies at premium private multi-specialty hubs and save up to <strong>70%</strong> on comprehensive cancer regimens without sacrificing safety or clinical excellence.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(40,167,69,0.2)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Request Free Private Cancer Care Opinion →
        </Link>
      </div>

      {/* SECTION 1: PRECISION ONCOLOGY TECHNOLOGIES */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Elite Precision Oncology Technologies Available in Private Facilities
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '15px', fontSize: '0.95rem' }}>
          Private oncology hubs across Delhi NCR continuously deploy advanced diagnostic and treatment technologies to deliver highly individualized, successful treatment pathways:
        </p>
        
        <div style={{ background: '#f4f8fb', padding: 'clamp(15px, 4vw, 20px)', margin: '20px 0', borderRadius: '6px', borderLeft: '4px solid #e63946', border: '1px solid #e2e8f0', borderLeftColor: '#e63946', boxSizing: 'border-box' }}>
          <h3 style={{ marginTop: '0', color: '#0b3c5d', fontSize: '1.15rem', marginBottom: '12px' }}>🎯 Precision Oncology Technologies Available:</h3>
          <ul style={{ marginTop: '10px', listStyleType: 'square', paddingLeft: '20px', lineHeight: '1.8', color: '#333', fontSize: '0.95rem' }}>
            <li style={{ marginBottom: '8px' }}><strong>PET-CT Scan & Advanced Molecular Pathology Diagnostics:</strong> High-resolution metabolic imaging combined with cutting-edge genomic sequencing to target tumor profiles at the molecular level.</li>
            <li style={{ marginBottom: '8px' }}><strong>Targeted Therapy & Immunotherapy:</strong> Next-generation biological treatments custom-tailored to a patient's specific genetic profile, training the body's natural immune system to identify and eliminate cancer cells.</li>
            <li style={{ marginBottom: '8px' }}><strong>Minimally Invasive Robotic Cancer Resections:</strong> Utilizing computer-assisted systems like the DaVinci surgical platform to execute precise tumor removals with minimal blood loss, minimal scar tissue, and accelerated recovery times.</li>
            <li style={{ marginBottom: '0' }}><strong>Advanced Radiosurgery Systems:</strong> Access to cutting-edge non-invasive platforms including CyberKnife stereotactic radiosurgery and highly precise Proton Beam Therapy to eradicate complex tumors safely.</li>
          </ul>
        </div>
      </section>

      {/* SECTION 2: ESTIMATED COST MATRIX - SAFELY WRAPPED FOR MOBILE */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Estimated Global Costs: Private Oncology Treatment Comparison
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Financial clarity is essential when mapping a medical travel itinerary for specialized cancer treatments. The statistics below reflect broad market estimates compiled from open public registries, comparing private healthcare markets globally:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(12px, 4vw, 20px)', margin: '25px 0', borderRadius: '4px', borderLeft: '4px solid #005ba1', border: '1px solid #e2e8f0', borderLeftColor: '#005ba1', boxSizing: 'border-box' }}>
          <h3 style={{ marginTop: '0', color: '#005ba1', fontSize: '1.2rem', marginBottom: '10px' }}>📊 Estimated Private Cancer Care Benchmarks (USD):</h3>
          
          {/* Scroll Protective Wrapper Box */}
          <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', margin: '15px 0 5px 0' }}>
            <table style={{ width: '100%', minWidth: '650px', borderCollapse: 'collapse', color: '#333', textAlign: 'left', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #ddd' }}>
                  <th style={{ padding: '10px 8px' }}>Treatment Modality</th>
                  <th style={{ padding: '10px 8px' }}>United States (Private)</th>
                  <th style={{ padding: '10px 8px' }}>United Kingdom (Private)</th>
                  <th style={{ padding: '10px 8px', color: '#28a745' }}>Global Range (Delhi NCR Private)</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Robotic Tumorectomy / Resection</strong></td>
                  <td style={{ padding: '10px 8px' }}>$45,000+</td>
                  <td style={{ padding: '10px 8px' }}>$24,000+</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#28a745' }}>$5,500 - $8,500</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>CyberKnife Radiosurgery (Full Cycle)</strong></td>
                  <td style={{ padding: '10px 8px' }}>$60,000+</td>
                  <td style={{ padding: '10px 8px' }}>$35,000+</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#28a745' }}>$6,000 - $9,000</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Autologous Bone Marrow Transplant</strong></td>
                  <td style={{ padding: '10px 8px' }}>$150,000+</td>
                  <td style={{ padding: '10px 8px' }}>$70,000+</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#28a745' }}>$15,000 - $22,000</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <p style={{ margin: '10px 0 0 0', fontSize: '0.8rem', color: '#666', lineHeight: '1.5' }}>
            <em>*Data Notice: The financial values listed above serve solely as an informational reference. Exact clinical quotations are subject to specific private institution selection, advanced molecular diagnostics, specific chemotherapy drug lines, staging variances, and customized inpatient tracking.</em>
          </p>
        </div>
      </section>

      {/* SECTION 3: MULTIDISCIPLINARY QUALITY PROTOCOLS - RESPONSIVE MOBILE GRID */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Patient Safety and Multidisciplinary Tumor Boards
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World functions strictly as an independent informational directory, we advise traveling patients to verify clinical infrastructures independently. Ensure your prospective private cancer hospital utilizes these essential care quality pillars:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Collaborative Tumor Boards</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Confirm that your care protocol is reviewed by an integrated multi-specialty board consisting of surgical oncologists, medical oncologists, radiation specialists, radiologists, and molecular pathologists to construct a highly optimized, accurate therapeutic roadmap.
            </p>
          </div>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>HEPA Positive-Pressure Suites</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              For advanced treatments that drastically affect white blood cell lines, verify that the private infrastructure houses dedicated positive-pressure intensive care isolation units backed by HEPA air-filtration systems to manage zero-infection goals.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e2e8f0', padding: 'clamp(15px, 4vw, 25px)', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem', fontWeight: '700' }}>
          Frequently Asked Questions (FAQs) – Private Cancer Care Travel
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Can an international patient begin cancer treatment in Delhi NCR immediately?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Yes. Premium private networks across New Delhi and Gurgaon do not utilize waitlists for international passport holders. Once pre-travel medical histories are validated and a specialized Medical Visa is obtained, physical diagnostic re-evaluations and treatments can begin within 24 to 48 hours of landing.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Are foreign molecular biopsy records accepted by private Indian oncology teams?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Yes, high-resolution pathology reports, block tissues, and genomic sequencing data translated into English are readily analyzed by international consulting panels. However, localized oncologists routinely order minor blood validation runs or baseline PET-CT imaging to confirm exact staging parameters before executing therapies.
          </p>
        </div>
        
        <div style={{ marginBottom: '0' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Does Medical Trip World retain commercial contracts with specific cancer clinics?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World serves exclusively as an independent informational platform and resource index. We do not maintain commercial affiliations, formal partnerships, or active Memorandums of Understanding (MOUs) with any medical facility or corporate hospital network. All pricing agreements, medical assessments, and clinical obligations occur solely and directly between the patient and their independently selected private provider.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Empower Your Global Healthcare Research Journey Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <Link to="/submit-query" className="oncology-footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block', boxShadow: '0 2px 4px rgba(40,167,69,0.15)' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="oncology-footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default Oncology;